"use client";

import ImageWrapper from "../ImageWrapper";

interface Props {
    brand: string;
    model: string;
    price: string;
    image: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
}

const ThankYouCheckboxCard = ({
    brand,
    model,
    price,
    image,
    checked = false,
    onChange,
    disabled = false,
}: Props) => {
    return (
        <div className="max-[767px]:flex-none max-[767px]:w-50.25 max-[767px]:max-w-none">
            <label className="box-border rounded w-full m-0 p-0 block overflow-hidden">
                <input
                    type="checkbox"
                    className="peer opacity-0 w-px h-px absolute"
                    checked={!!checked}
                    disabled={!!disabled}
                    onChange={(e) => onChange && onChange(e.target.checked)}
                />

                <span className={`cursor-pointer bg-white rounded flex-col w-full transition-all duration-150 flex relative overflow-hidden before:content-[''] before:absolute before:bg-white before:bg-[url(https://static-asset.tractorjunction.com/cj/check.svg)] before:bg-position-[50%_60%] before:bg-no-repeat before:bg-size-[10px] before:border before:border-solid before:border-[gray] before:rounded before:w-4 before:h-4 before:top-1.75 before:right-3.75 peer-checked:before:bg-black after:content-[''] after:absolute after:inset-0 after:rounded-lg after:border-[0.5px] after:border-solid after:border-[#c2c2c2] max-[767px]:before:w-3.5 max-[767px]:before:h-3.5 max-[767px]:before:top-2 max-[767px]:before:right-2 ${disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}>
                    <span className="h-28 overflow-hidden max-[767px]:h-25.25">
                        <ImageWrapper
                            src={image}
                            alt={`${brand} ${model}`}
                            title={`${brand} ${model}`}
                            width={300}
                            height={200}
                            className="w-full h-full object-cover rounded-t-lg"
                            loading="lazy"
                        />
                    </span>

                    <span className="truncate text-[#6a7282] text-[11px] font-normal pt-2 px-2.5 pb-0 max-[767px]:pt-3 max-[767px]:pb-1">
                        {brand}
                    </span>

                    <span className="truncate text-[#101828] text-[16px] leading-none font-normal py-1 px-2.5 max-[767px]:pt-0 max-[767px]:pb-2.5">
                        {model}
                    </span>

                    <span className="truncate text-[#101828] text-[12px] font-normal pt-0 px-2.5 pb-2 max-[767px]:pb-3">
                        {price !== "Price on request" ? <>{price}<span className="text-[11px] text-[#62748E] font-normal ml-0.5">* onwards</span></> : price}
                    </span>
                </span>
            </label>
        </div>
    );
};

export default ThankYouCheckboxCard;